import React from 'react';

import { Box, Typography } from '@mui/material';

import { LereToursPricingSuggestion } from '../types';

export default function ToursIdsFormatter({ row }: { row: LereToursPricingSuggestion }) {
  return (
    <Box sx={{ alignSelf: 'flex-start', py: 1, wordBreak: 'break-all' }}>
      <Typography variant="body2" fontWeight="bold">
        Offer ID:
      </Typography>
      <Typography variant="body2">{row.offer_bk || '—'}</Typography>
      <Typography variant="body2" fontWeight="bold" sx={{ mt: 0.5 }}>
        Salesforce ID:
      </Typography>
      <Typography variant="body2">{row.offer_salesforce_bk || '—'}</Typography>
      <Typography variant="body2" fontWeight="bold" sx={{ mt: 0.5 }}>
        Departure Name:
      </Typography>
      <Typography variant="body2">{row.departure_name || '—'}</Typography>
    </Box>
  );
}
